import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModalModule } from '@cmps/ng-bootstrap';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../route.module';

import { TranslationIdMap } from './auth.i18n';
import { AuthRoutes } from './auth.route';
import { AuthService } from './auth.service';
import { EmailResetAuthComponent } from './email-reset.auth.component';
import { LoginAuthComponent } from './login';
import { TranslationIdMap as TranslationIdMapLogin } from './login/login.auth.i18n';
import { LogoutAuthComponent } from './logout.auth.component';
import { LoginModalAuthComponent } from './modal.login.auth.component';
import { QuestionResetAuthComponent } from './question-reset.auth.component';
import { ResetPasswordAuthComponent } from './reset-password.auth.component';
import { ResetAuthComponent } from './reset.auth.component';
import { ValidateAuthComponent } from './validate/validate.auth.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModalModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyI18nModule.forChild(TranslationIdMapLogin),
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(AuthRoutes),
        CmpsDialogModule,
        CmpsIconModule,
        CmpsButtonModule,
    ],
    declarations: [
        LoginAuthComponent,
        LoginModalAuthComponent,
        LogoutAuthComponent,
        ResetAuthComponent,
        EmailResetAuthComponent,
        QuestionResetAuthComponent,
        ResetPasswordAuthComponent,
        ValidateAuthComponent,
    ],
})
export class CmpsAuthModule {
    static forRoot(): ModuleWithProviders<CmpsAuthModule> {
        return {
            ngModule: CmpsAuthModule,
            providers: [AuthService],
        };
    }
}
